export default __webpack_public_path__ + "static/media/facility4.51dca6ac.jpg";